import Timetable from '@/views/Timetable'
import TrafficLocations from '@/views/TrafficLocations'

export default [
  {
    path: '/',
    redirect: '/timetable'
  },
  {
    path: '/timetable',
    component: Timetable
  },
  {
    path: '/traffic-locations',
    component: TrafficLocations
  }
]
